import React from 'react'

const Arrow = ({
  width = 60,
  height = 60,
  responsive = true,
  ...props
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 60"
      aria-hidden="true"
      focusable="false"
      {...svgAttributes}
      {...props}
    >
      <path d="M58.1213 0.75V1.5H58.8713V35.5879H57.3713V3.31055L2.65161 58.0303L1.59106 56.9697L56.3108 2.25H21.6018V0.75H58.1213Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/>
    </svg>
  )
}

export default Arrow